import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import {QueryResultType} from 'graphql-client/BenchlingQuery';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import useWarehouseModelsQuery from '../useWarehouseModelsQuery';
import {WarehouseModelData} from '../warehouseModelsDataLayout';
import DiagramError from './DiagramError';
import WarehouseDiagram from './WarehouseDiagram';

export interface WarehouseDiagramWrapperProps {
  schemaName: string;
  focusTableName: string;
}

export default function WarehouseDiagramWrapper(props: WarehouseDiagramWrapperProps): JSX.Element {
  const warehouseModelsResult = useWarehouseModelsQuery({sortColumns: true});
  switch (warehouseModelsResult.queryResultType) {
    case QueryResultType.SUCCESS: {
      const transformedData = warehouseModelsResult.transformedData;
      if (transformedData.get(props.schemaName)?.tables.get(props.focusTableName) != null) {
        return (
          <WarehouseDiagram
            schemaName={props.schemaName}
            focusTableName={props.focusTableName}
            warehouseModels={transformedData.get(props.schemaName) as WarehouseModelData}
          />
        );
      } else {
        assertAndContinue(false, `Could not find warehouse table`, {
          schemaName: props.schemaName,
          tableName: props.focusTableName,
        });
        return <DiagramError errorMessage="Failed to load entity diagram for this table" />;
      }
    }
    case QueryResultType.PENDING:
      return (
        <div className={classNames(css(styles.throbberWrapper), 'u-text-align-center')}>
          <HorizontalThrobber />
        </div>
      );
    default:
      return <DiagramError errorMessage="Failed to load entity diagram data" />;
  }
}

const styles = StyleSheet.create({
  throbberWrapper: {
    marginTop: '16px',
  },
});
